import * as React from 'react';
import './checkPointsPane.module.scss';
import { observer } from 'mobx-react';
import { CheckCard } from '../../molecules/cards/CheckCard';
import { ServiceAgreement } from '../../../../commonv3/types/serviceAgreements';

type Props = {
  serviceAgreement: ServiceAgreement;
  cardsChecked: boolean[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCheck: (i: number, checked: boolean) => any;
};

export const CheckPointsPane = observer(({ serviceAgreement, cardsChecked, onCheck }: Props) => {
  const { check_points } = serviceAgreement;
  return (
    <div styleName="check-points-wrapper">
      <div styleName="check-points-header">特によくご理解していただきたい内容</div>
      <div styleName="check-points-items">
        {cardsChecked &&
          check_points.map((check_point, index) => (
            <CheckCard
              key={index}
              title={check_point.title}
              text={check_point.text}
              checked={cardsChecked[index]}
              onCheck={(checked) => onCheck(index, checked)}
            />
          ))}
      </div>
    </div>
  );
});
